<template>
  <div class="admin-auth">
    <div class="auth-container">
      <h2>Admin Authentication</h2>
      <div class="input-group">
        <input 
          type="password" 
          v-model="password"
          placeholder="Enter admin password"
          @keyup.enter="verifyPassword"
        />
        <button @click="verifyPassword" :disabled="isVerifying">
          {{ isVerifying ? 'Verifying...' : 'Access Dashboard' }}
        </button>
      </div>
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import CryptoJS from 'crypto-js'

export default {
  name: 'AdminAuth',
  setup() {
    const router = useRouter()
    const password = ref('')
    const error = ref('')
    const isVerifying = ref(false)
    const targetHash = 'ee538679626589f280ae98ec6edfb9d3a0edfb0ccabecfb6395adb3a3a8e3a0c'

    const verifyPassword = async () => {
      if (!password.value) {
        error.value = 'Please enter the password'
        return
      }

      isVerifying.value = true
      error.value = ''

      try {
        const hashedPassword = CryptoJS.SHA256(password.value).toString()
        
        if (hashedPassword === targetHash) {
          // Set cookie that expires in 24 hours
          const expiryDate = new Date()
          expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000))
          document.cookie = `adminAuth=${hashedPassword};expires=${expiryDate.toUTCString()};path=/`
          
          router.push('/dashboard')
        } else {
          error.value = 'Invalid password'
        }
      } catch (err) {
        error.value = 'An error occurred during verification'
        console.error('Verification error:', err)
      } finally {
        isVerifying.value = false
      }
    }

    return {
      password,
      error,
      isVerifying,
      verifyPassword
    }
  }
}
</script>

<style scoped>
.admin-auth {
  height: 90dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.auth-container {
  background: rgba(26, 27, 46, 0.95);
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  max-width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

h2 {
  margin: 0 0 24px 0;
  color: var(--text-primary);
  text-align: center;
  font-size: 24px;
  background: linear-gradient(135deg, var(--primary-color), var(--gradient-2));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

input {
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: var(--text-primary);
  font-size: 16px;
  transition: all 0.3s ease;
}

input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.2);
}

button {
  padding: 14px;
  background: linear-gradient(135deg, var(--primary-color), var(--gradient-2));
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 99, 255, 0.3);
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error-message {
  margin-top: 16px;
  color: #ff4757;
  text-align: center;
  font-size: 14px;
}
</style> 